// extracted by mini-css-extract-plugin
module.exports = {"instructions":"Instructions_instructions__11Qu0","description":"Instructions_description__3zned"};